import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';

import {
  subMenuDropdownBackground,
  primaryColorLight,
  primaryColorWeak,
  outlineGray,
} from '../../config/colors';
import Button from '../Button';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${subMenuDropdownBackground};
  padding: 20px 30px;
`;

export const TableTitle = styled.input`
  height: 40px;
  margin-bottom: 35px;
  margin-right: 50px;
  border: 2px solid ${outlineGray};
  border-radius: 3px;
  padding: 5px 10px;
  font-size: 0.875rem;
  text-align: start;
`;

export const TableWrapper = styled.div`
  width: 100%;
  table {
    width: 100%;
    text-align: center;
    border-spacing: 0;
    border-collapse: collapse;
    table-layout: fixed;
    word-break: break-word;

    colgroup {
      col:nth-child(1) {
        width: 20%;
      }
      col:nth-child(2) {
        width:40%;
      }
      col:nth-child(3) {
        width: 35%;
      }
      col:nth-child(4) {
        width: 5%;
      }
    }
  }
  tbody {
    background-color: white;
  }
  td,
  th {
    border: 2px solid ${primaryColorLight};
    font-size: 0.781rem;
  }
  th {
    padding: 5px;
    background-color: ${primaryColorWeak};
    font-size: 0.875rem;
  }
  thead {
    tr:nth-child(2) {
      th:nth-child(4),
      th:nth-child(5),
      th:nth-child(6),
      th:nth-child(7),
      th:nth-child(8),
      th:nth-child(9),
      th:nth-child(11),
      th:nth-child(12),
      th:nth-child(13) {
        background-color: whiteSmoke;
        font-size: 0.781rem;
        font-weight: 800;
      }
    }

    tr:nth-child(3) {
      th:nth-child(5),
      th:nth-child(6),
      th:nth-child(7),
      th:nth-child(8),
      th:nth-child(9),
      th:nth-child(11),
      th:nth-child(12),
      th:nth-child(13) {
        background-color: whiteSmoke;
        font-size: 0.781rem;
        font-weight: 800;
      }
    }
  }
    th:last-child,
    tr:nth-child(2) > th:last-child,
    tr:nth-child(3) > th:last-child {
      border: 0px;
      background-color: ${subMenuDropdownBackground};
    }
  }

  tr {
    td:first-child {
      width: 20%;
    }
      td:nth-child(2) {
          width: 40%;
      }
      td:nth-child(3) {
          width: 35%;
      }
    td:last-child {
      width: 5%;
      border: 0px;
      background-color: ${subMenuDropdownBackground};
    }
  }
`;

export const RemoveRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '25px',
    height: '25px',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '16px',
  },
})``;

export const AddNewRowBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '60%',
    height: '40px',
    alignSelf: 'center',
    marginTop: '20px',
  },
  textStyle: {
    fontSize: '1rem',
  },
})``;
